<template>
	<div class="ksm-flex-xy-center">
		<h1 style="width:100%; text-align: center;color: grey">
			Kontakt			
		</h1>
	</div>
</template>

<script>
	export default {
		data() {
			return {}
		},
		methods: {

		}

	}
</script>

<style lang="scss"
 scoped>

</style>


// WEBPACK FOOTER //
// Kontakt.vue?0fb8979a